// Enter all your detials in this file
// Logo images
import logogradient from "./assets/logogm.png";
import logo from "./assets/logo.png";
// Profile Image
import profile from "./assets/profile.png";
// Tech stack images ABC
import html from "./assets/techstack/html.png";
import css from "./assets/techstack/css.png";
import sass from "./assets/techstack/sass.png";
import js from "./assets/techstack/js.png";
import typescript from "./assets/techstack/typescript.png";
import chash from "./assets/techstack/chash.png";
import angular from "./assets/techstack/angular.png";
import tailwind from "./assets/techstack/tailwind.png";
import bootstrap from "./assets/techstack/bootstrap.png";
import dotnetcore from "./assets/techstack/dotnetcore.png";
import react from "./assets/techstack/react.png";
import node from "./assets/techstack/node.png";
import xd from "./assets/techstack/xd.png";
import vscode from "./assets/techstack/vscode.png";
import github from "./assets/ui/github.svg";
import git from "./assets/techstack/git.png";
import npm from "./assets/techstack/npm.png";
import postman from "./assets/techstack/postman.png";
import figma from "./assets/techstack/figma.png";
import abl from "./assets/company/abllogo.png";
import netsol from "./assets/company/netsollogo.png";
import systems from "./assets/company/systemlogo.jpg";
import amal from "./assets/company/amallogo.png";
import gcuf from "./assets/company/gcuflogo.jpg";
import pin from "./assets/company/location.png";
// Porject Images
import projectImage1 from "./assets/projects/project1.jpg";
import projectImage2 from "./assets/projects/project2.jpg";
import projectImage3 from "./assets/projects/project3.jpg";
import projectImage4 from "./assets/projects/project4.jpg";
import projectImage5 from "./assets/projects/project5.jpg";
import projectImage6 from "./assets/projects/project6.jpg";

// Logos
export const logos = {
  logogradient: logogradient,
  logo: logo,
};

// Enter your Personal Details here
export const personalDetails = {
  name: "GHULAM MAHYODIN(GM)",
  title: "Full Stack Developer",
  tagline:
    "Angular 🔥| Node js ⌨️ | .Net / .Net Core 😘 | JavaScript 😎| TypeScript ❤️ | Microservices 💫 | Entity Framework 💥",
  img: profile,
  about: `I'm a Full Stack Developer 🧑‍💻 with expertise in Angular 🅰️ and .NET 💻 technologies. A proud graduate 🎓 of GC University Faisalabad, I'm passionate about creating robust and innovative web applications that provide seamless user experiences.🌐 My journey in software development has equipped me with the skills to tackle complex challenges and deliver high-quality solutions. Let's connect and explore opportunities to collaborate!🚀`,
};

// Enter your Social Media URLs here
export const socialMediaUrl = {
  linkdein: "https://www.linkedin.com/in/ghulam-mahyodin/",
  github: "https://github.com/GhulamMuhyodin",
  twitter: "https://twitter.com/",
  instagram: "https://www.instagram.com/",
};

// Enter your Work Experience here
export const workDetails = [
  {
    Position: "Full Stack Angular Developer",
    Company: `Systems Limited`,
    Location: "Lahore, Pakistan",
    Type: "Full Time",
    Duration: "Nov 2023 - Current",
    CompanyLogo: systems,
    Pin: pin,
  },
  {
    Position: "Senior Software Engineer (Angular + .Net + NodeJS)",
    Company: `Netsol Technologies Inc`,
    Location: "Lahore, Pakistan",
    Type: "Full Time",
    Duration: "July 2023 - Nov-2023",
    CompanyLogo: netsol,
    Pin: pin,
  },
  {
    Position: "Software Engineer (Angular + .Net + NodeJS)",
    Company: `Netsol Technologies Inc`,
    Location: "Lahore, Pakistan",
    Type: "Full Time",
    Duration: "Feb 2022 - June 2023",
    CompanyLogo: netsol,
    Pin: pin,
  },

  {
    Position: "Software Engineer (.Net)",
    Company: `Allied Bank Limited`,
    Location: "Lahore, Pakistan",
    Type: "Full Time",
    Duration: "Oct 2019 - Feb 2022",
    CompanyLogo: abl,
    Pin: pin,
  },
];

// Enter your Education Details here
export const eduDetails = [
  {
    Position: "Amal Career-prep Fellowship ",
    Company: `Amal Academy `,
    Location: "Lahore, Pakistan",
    Type: "Full Time",
    Duration: "Mar 2022 - June-2022",
    CompanyLogo: amal,
    Pin: pin,
  },
  {
    Position: "Bachelor in Computer Science",
    Company: `Government Collage University (GCUF) Faisalabad`,
    Location: "Pakistan",
    Type: "Full Time",
    Duration: "Sep 2015 - Aug 2019",
    CompanyLogo: gcuf,
    Pin: pin,
  },
];

// Tech Stack and Tools
export const techStackDetails = {
  html: html,
  css: css,
  js: js,
  typescript: typescript,
  chash: chash,
  angular: angular,
  dotnetcore: dotnetcore,
  sass: sass,
  node: node,
  react: react,
  xd: xd,
  tailwind: tailwind,
  bootstrap: bootstrap,
  vscode: vscode,
  postman: postman,
  npm: npm,
  git: git,
  github: github,
  figma: figma,
};

// Enter your Project Details here
export const projectDetails = [
  {
    title: "E-Governace System",
    image: projectImage1,
    description: `An automated an e-governance framework aims to streamline and expedite the review and approval process for vital cabinet summaries. These summaries encapsulate policy proposals, decisions, and recommendations necessitating endorsement from the cabinet or executive decision-making body. The project aimed to modernize the design, improve navigation, and optimize page load times.`,
    techstack: "Angular ,HTML/CSS, JavaScript, .Net Core, MySQL, C#",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "User Management System",
    image: projectImage2,
    description: `In this project, I led the revamp of the existing User Management System to enhance its functionality, user experience, and overall efficiency. The goal was to create a seamless and intuitive system that catered to the needs of both administrators and end-users.`,
    techstack: "Angular ,HTML/CSS, JavaScript, .Net Core, MySQL, C#",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Reporting System",
    image: projectImage3,
    description: `The integration of Project Description Reports into the E-Governance System is a significant step towards achieving transparency, accountability, and efficiency in government projects. While there may be challenges to overcome, the long-term benefits for citizens, government officials, and decision-makers make this integration a worthwhile endeavor.`,
    techstack: "Angular ,HTML/CSS, JavaScript, .Net Core, MySQL, C#",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },

  {
    title: "Home Remittance System",
    image: projectImage6,
    description: `Home Remittance System (HRS) project is a financial services initiative designed to facilitate the transfer of money from individuals working abroad (often referred to as "remitters") to their families or recipients back in their home country. This system aims to streamline and secure the process of remittance, which is a crucial source of income for many families in developing countries.`,
    techstack: " .Net, SQL Server, C#",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "PRC",
    image: projectImage4,
    description: `A Realization Certificate, as the term suggests, is typically a document or certification that acknowledges the successful realization or completion of a particular transaction`,
    techstack: "HTML/CSS, Web Forms, .Net, SQL Server, C#",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
  {
    title: "Local Payment Gateway",
    image: projectImage5,
    description: `A local payment gateway project involves creating a system or platform that facilitates online transactions within a specific geographic region or locality. This payment gateway allows businesses and consumers within that region to make electronic payments for goods and services securely and efficiently.`,
    techstack: " .Net, SQL Server, C#",
    previewLink: "https://google.com",
    githubLink: "https://github.com",
  },
];

// Enter your Contact Details here
export const contactDetails = {
  email: "gmuhyodin@gmail.com",
  phone: "+92 301 705 7714",
};
